import React from 'react';
import { Button } from '@/components/ui/button';

const PageHeader = ({
  eyebrow,
  title,
  description,
  counts = [],
  primaryCtaLabel,
  onPrimaryCta,
  secondaryActions,
}) => {
  return (
    <div className="flex flex-col gap-3">
      {eyebrow ? (
        <p className="text-xs font-bold uppercase tracking-wider text-[#0A84FF]">{eyebrow}</p>
      ) : null}
      <div className="flex flex-wrap items-start justify-between gap-4">
        <div className="flex max-w-[840px] flex-col gap-1">
          <h1 className="text-balance text-2xl font-extrabold tracking-tight text-label-primary lg:text-3xl">{title}</h1>
          {description ? <p className="text-pretty text-sm leading-relaxed text-label-secondary">{description}</p> : null}
          {counts.length > 0 ? (
            <div className="mt-1 flex flex-wrap gap-2">
              {counts.map((item) => (
                <span key={item.label} className="tabular-nums text-xs text-label-tertiary">
                  {item.label}: {item.value}
                </span>
              ))}
            </div>
          ) : null}
        </div>

        <div className="flex flex-wrap gap-2">
          {secondaryActions || null}
          {primaryCtaLabel && onPrimaryCta ? (
            <Button size="sm" className="bg-brand-500 hover:bg-brand-600" onClick={onPrimaryCta}>
              {primaryCtaLabel}
            </Button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default PageHeader;
